import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

/**
 * Feature flag class to enable or disable admixtures collections.
 */
@Injectable()
export class CallActionsBlkAdt implements IFlagFeature {
  name = Features.CALL_ACTIONS_BLK_ADT;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
